import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AtcSystemService {
    private _atcSystemUrl = new BehaviorSubject<string>(
        environment.atcSystemUrl
    );

    get atcSystemUrl$(): Observable<string> {
        return this._atcSystemUrl.asObservable();
    }

    set atcSystemUrl$(url: string) {
        this._atcSystemUrl.next(url);
    }

    constructor() {}
}
